var map = {
	"./classify_icon_a1.svg": 52276,
	"./classify_icon_a2.svg": 46729,
	"./classify_icon_a3.svg": 37359,
	"./classify_icon_a4.svg": 17550,
	"./classify_icon_a5.svg": 25824,
	"./classify_icon_a6.svg": 63353,
	"./classify_icon_a7.svg": 13601,
	"./classify_icon_a8.svg": 32303,
	"./classify_icon_a9.svg": 43039
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67867;